import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Signup = styled.div`
  height: 100vh;
  overflow: hidden;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;
export const SignupLeftBox = styled.div`
  flex: 0 0 45%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  color: ${({ theme }) => theme.palette.white};
  text-align: center;
`;
export const SignupImageBox = styled.div`
  height: 100%;
  padding: ${({ theme }) => `5em ${theme.spacing.x12}`};
`;

export const SignupTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;

export const SignupSecondTitle = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.x12};
  color: ${({ theme }) => theme.palette.white};
`;
export const SignupLinkImage = styled.div`
  margin-top: auto;
  color: ${({ theme }) => theme.palette.white};
`;
export const SignupFormContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.x10} ${({ theme }) => theme.spacing.x10};
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
export const SignupForm = styled.form`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
export const SignupFormButton = styled.div`
  margin: ${({ theme }) => theme.spacing.x8} auto;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const sendtoLoginPage = styled.p`
  margin-top: ${({ theme }) => theme.spacing.x2};
  text-decoration: underline;
  color:${({ theme }) => theme.palette.secondary};
`;

export const RepresentiveForm = styled.div``;

export const FormAnnouncement = styled.p`
  font-size: ${({ theme }) => theme.fs.xs};
  color: ${({ theme }) => theme.palette.lightGray};
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.x2};
`;
